import React from 'react';
import { Card } from "antd";

export default () => {
  return <Card bordered={false} loading/>;
};